import React from 'react'

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
  helperText?: string
}

const Input: React.FC<InputProps> = ({
  label,
  error,
  helperText,
  className = '',
  ...props
}) => {
  const baseClasses = 'w-full px-3 py-2 rounded-lg shadow-sm focus:outline-none focus:ring-2 transition-all'
  const lightModeClasses = 'bg-white border-gray-300 text-gray-900 placeholder-gray-400 focus:ring-blue-500 focus:border-blue-500'
  const darkModeClasses = 'dark:bg-white/10 dark:border-white/20 dark:text-white dark:placeholder-white/50 dark:focus:ring-blue-400 dark:focus:border-blue-400'
  const errorClasses = error 
    ? 'border-red-300 focus:ring-red-500 focus:border-red-500 dark:border-red-500/50 dark:focus:ring-red-400' 
    : 'border'

  const inputClasses = `${baseClasses} ${lightModeClasses} ${darkModeClasses} ${errorClasses} ${className}`

  return (
    <div className="space-y-1">
      {label && (
        <label className="block text-sm font-medium text-gray-700 dark:text-white/90">
          {label}
        </label>
      )}
      <input className={inputClasses} {...props} />
      {error && (
        <p className="text-sm text-red-600 dark:text-red-400">{error}</p>
      )}
      {helperText && !error && (
        <p className="text-sm text-gray-500 dark:text-white/60">{helperText}</p>
      )}
    </div>
  )
}

export default Input
